import React from "react";
import { Dialog, Box, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

const DeclarationModal = ({
	open,
	title,
	description,
	onClose
}: {
	title: string;
	open: boolean;
	onClose: () => void;
	description?: React.ReactNode;
}) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
			<Box display="flex" justifyContent="flex-end" style={{ position: "absolute", right: "20px", top: "20px" }}>
				<IconButton onClick={onClose}>
					<Close />
				</IconButton>
			</Box>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">{description}</DialogContentText>
			</DialogContent>
		</Dialog>
	);
};

export default DeclarationModal;
